import { render, staticRenderFns } from "./PointSecuritymoneyError.vue?vue&type=template&id=3b6cee45"
import script from "./PointSecuritymoneyError.vue?vue&type=script&lang=js"
export * from "./PointSecuritymoneyError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports